export const API_URL =
	process.env.NODE_ENV === 'development'
		? 'http://localhost:4000'
		: 'https://web-production-9df3.up.railway.app';
